import { GridFilter, type GridFilterGroup } from "../../store/grid.store.model";

const SWITCH_PRESENTATION = "switch";
const ON_VALUE_LC = "on";
const OFF_VALUE_LC = "off";

function hasOnlyOnFilterSelected(filterGroup: GridFilterGroup): boolean {
    const selectedFilters = filterGroup.filters?.filter(
        (filter) => filter.selected,
    );

    return (
        selectedFilters.length === 1 &&
        selectedFilters[0].name.toLowerCase() === ON_VALUE_LC
    );
}

/**
 * Indicate whether a filterGroup is a "switch"
 * @param filterGroup
 * @returns true when filter have switch presentation
 */
export function isSwitchFilter(filterGroup: GridFilterGroup): boolean {
    return filterGroup.presentation === SWITCH_PRESENTATION;
}

/**
 * Indicate whether a filterGroup with presentation "switch" is active
 * A switch filter group is active if, and only if, its "On" filter is selected.
 * @param filterGroup
 * @returns true when switch filter is active "ON"
 */
export function isSwitchFilterActive(filterGroup: GridFilterGroup): boolean {
    return isSwitchFilter(filterGroup) && hasOnlyOnFilterSelected(filterGroup);
}

/**
 * Mutate provided filterGroup to set its active status
 * @param filterGroup
 * @param active
 * @returns the internal selected filter ("On" or "Off")
 */
export function setSwitchFilterActive(
    filterGroup: GridFilterGroup,
    active: boolean,
): GridFilter {
    const onFilter = filterGroup.filters.find(
        (filter) => filter.name.toLowerCase() === ON_VALUE_LC,
    ) as GridFilter;
    const offFilter = filterGroup.filters.find(
        (filter) => filter.name.toLowerCase() === OFF_VALUE_LC,
    ) as GridFilter;

    if (onFilter) {
        onFilter.selected = active;
    }

    if (offFilter) {
        offFilter.selected = !active;
    }

    return active ? onFilter : offFilter;
}
